export const smoothScroll = () => {
  const getTargetElement = (hash: string) => {
    const targetId = decodeURIComponent(hash.replace(/^#/, ""));
    if (!targetId) return null;

    return document.getElementById(targetId);
  };

  const scrollToTarget = (hash: string) => {
    const targetElement = getTargetElement(hash);
    if (!targetElement) return;

    const header = document.querySelector("header");
    const headerHeight = header ? header.offsetHeight : 0;

    const targetOffsetTop = window.scrollY + targetElement.getBoundingClientRect().top;

    window.scrollTo({
      top: targetOffsetTop - headerHeight,
      behavior: "smooth",
    });
  };

  const handleAnchorClick = (e: Event) => {
    const link = e.currentTarget as HTMLAnchorElement;
    const href = link.getAttribute("href");

    if (!href) return;

    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;

    const hash = url.hash;
    if (!hash || hash === "#") return;

    const targetElement = getTargetElement(hash);
    if (!targetElement) return;

    e.preventDefault();
    scrollToTarget(hash);
  };

  const anchorLinks = document.querySelectorAll('a[href*="#"]');
  anchorLinks.forEach((link) => {
    link.addEventListener("click", handleAnchorClick);
  });
  if (window.location.hash) {
    scrollToTarget(window.location.hash);
  }
};
